var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
var ConfigContext = createContext(null);
export var ConfigProvider = function (_a) {
    var children = _a.children, config = _a.config;
    return (_jsx(ConfigContext.Provider, { value: __assign({}, config), children: children }));
};
export var useConfig = function () {
    var config = useContext(ConfigContext);
    if (!config) {
        throw new Error('EventComposerConfig is not set');
    }
    if (!config.environmentUrls.baseApiUrl) {
        throw new Error('Base API URL is not set');
    }
    return __assign(__assign({}, config), { environmentUrls: __assign(__assign({}, config.environmentUrls), { baseApiUrl: config.environmentUrls.baseApiUrl }) });
};
